import { render, staticRenderFns } from "./targeting-form.vue?vue&type=template&id=f705044e&scoped=true"
import script from "./targeting-form.vue?vue&type=script&setup=true&lang=js"
export * from "./targeting-form.vue?vue&type=script&setup=true&lang=js"
import style0 from "./targeting-form.vue?vue&type=style&index=0&id=f705044e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f705044e",
  null
  
)

export default component.exports